import type { WorkflowEventNames } from './types';

/** Pages that emit workflow events, each under its own event names. */
export type WorkflowSource = 'realtime' | 'databases';

export const WORKFLOW_EVENTS: Record<WorkflowSource, WorkflowEventNames> = {
  realtime: {
    started: '[RealtimeV2]workflow:started',
    // Kept until FE-844 confirms nobody relies on it; `completed` now carries
    // `submit_duration_ms`.
    submitted: '[RealtimeV2]workflow:submitted',
    completed: '[RealtimeV2]workflow:completed',
    abandoned: '[RealtimeV2]workflow:abandoned'
  },
  databases: {
    started: '[Databases]workflow:started',
    completed: '[Databases]workflow:completed',
    abandoned: '[Databases]workflow:abandoned'
  }
};

/**
 * Where a flow runs. Serializable, so it can travel with flows that finish
 * outside the page that started them (e.g. the global annotation-conflict
 * modal).
 */
export type WorkflowOrigin = {
  source: WorkflowSource;
  tab?: string;
};
